import { Link } from "react-router";

import { externalLink } from "@/routes/_constants/external-link";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";
import type { SiteControllerSettingBeds24FormModel } from "@/components/features/settings/site-controller/model/beds24/type";
import type { SiteControllerSettingBeds24FormModelMethodsType } from "@/components/features/settings/site-controller/model/beds24/use-case/use-create-model/methods";

import { RadioGroupField } from "@/components/ui/form/fields/radio-field/radio-group";

import { useBeds24SetUpRoomPriceByChillnn } from "./hooks";

type Props = {
	setUpRoomPriceByChillnn: SiteControllerSettingBeds24FormModel["ViewModel"]["setUpRoomPriceByChillnn"]; //
	onSetSetUpRoomPriceByChillnn: SiteControllerSettingBeds24FormModelMethodsType["siteControllerSettingBeds24FormModelMethods"]["onSetSetUpRoomPriceByChillnn"];
};

/**
 * CHILLNN サポート「サイコン接続 / Beds24の接続マニュアル」
 * https://support.chillnn.com/faq/host/site-controller/02bfffe15c5783e9b008815762fddf05
 *
 * ベースURLは externalLink.faqSite（dev/prd で自動切替）を使う。
 * パスは Notion ページ ID で構成されるため、日本語タイトルや旧スラッグは使わない。
 * 料金管理の方法ごとの説明は同じ記事の見出しにあるので、見出しのアンカーで飛ばす。
 */
const BEDS24_MANUAL_URL = `${externalLink.faqSite}/faq/host/site-controller/02bfffe15c5783e9b008815762fddf05`;
const CHILLNN_ARTICLE_URL = `${BEDS24_MANUAL_URL}#料金の設定方法-chillnnで料金管理する場合`;
const BEDS24_ARTICLE_URL = `${BEDS24_MANUAL_URL}#料金の設定方法-beds24で料金管理する場合`;

export const SettingsSiteControllerBeds24SetUpRoomPriceByChillnn = ({
	setUpRoomPriceByChillnn,
	onSetSetUpRoomPriceByChillnn: _onSetSetUpRoomPriceByChillnn,
}: Props) => {
	const { setUpRoomPriceByChillnnForRadioGroup, onSetSetUpRoomPriceByChillnn, setUpRoomPriceByChillnnOptions } =
		useBeds24SetUpRoomPriceByChillnn({
			setUpRoomPriceByChillnn,
			onSetSetUpRoomPriceByChillnn: _onSetSetUpRoomPriceByChillnn,
		});

	const articleTitleText =
		(setUpRoomPriceByChillnnForRadioGroup.value === "true"
			? `「${setUpRoomPriceByChillnnOptions[0].label}」`
			: `「${setUpRoomPriceByChillnnOptions[1].label}」`) + "に関する記事は";
	// 記事のURL
	const articleUrl =
		setUpRoomPriceByChillnnForRadioGroup.value === "true"
			? // CHILLNNで料金管理する場合の記事
				CHILLNN_ARTICLE_URL
			: // Beds24で料金管理する場合の記事
				BEDS24_ARTICLE_URL;

	return (
		<QuestionForMain
			required={false}
			title={"Beds24との料金連携"}
			inputChildren={
				<div className="space-y-4">
					<RadioGroupField
						value={setUpRoomPriceByChillnnForRadioGroup.value}
						options={setUpRoomPriceByChillnnOptions}
						handleValueChange={onSetSetUpRoomPriceByChillnn}
					/>
					<div className="flex gap-x-2">
						<p>{articleTitleText}</p>
						<Link
							to={articleUrl}
							target="_blank"
							className="text-link-400 underline-offset-4 hover:underline"
							viewTransition
						>
							こちら
						</Link>
					</div>
				</div>
			}
		/>
	);
};

SettingsSiteControllerBeds24SetUpRoomPriceByChillnn.displayName = "SettingsSiteControllerBeds24SetUpRoomPriceByChillnn";
